/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetNominationsQueryVariables = Types.Exact<{
  search: Types.CargoSearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetNominationsQuery = {
  __typename?: 'Query',
  cargos: {
    __typename?: 'CargoPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Cargo',
      id: number,
      cargoNumber?: string | null,
      weight?: number | null,
      volume?: number | null,
      nominationChanged?: boolean | null,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      firstLoadingAction?: {
        __typename?: 'CargoAction',
        start?: number | null,
        end?: number | null,
        displayAsWindow?: boolean | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        call?: {
          __typename?: 'Call',
          voyage: {
            __typename?: 'Voyage',
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string,
              eni?: string | null
            }
          }
        } | null
      } | null,
      lastDischargingAction?: {
        __typename?: 'CargoAction',
        start?: number | null,
        end?: number | null,
        displayAsWindow?: boolean | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null
      } | null,
      product?: {
        __typename?: 'Product',
        id: number,
        name: string
      } | null,
      comments: Array<{
        __typename?: 'Comment',
        id: number,
        comment: string,
        created: number,
        createdBy: {
          __typename?: 'AccountDetails',
          id: number,
          username?: string | null,
          displayName?: string | null
        },
        label?: {
          __typename?: 'Label',
          id: number,
          type: Types.LabelType,
          text: string,
          color: string
        } | null
      }>,
      preCargos?: Array<{
        __typename?: 'Product',
        id: number,
        name: string
      } | null> | null
    }>
  }
};


export const GetNominationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNominations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nominationChanged"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<GetNominationsQuery, GetNominationsQueryVariables>;